import React from 'react';
import lockIcon from '../../assets/lock.svg';

interface HeaderProps {
  defaultLogoUrl?: string;
}

const Header: React.FC<HeaderProps> = ({ 
  defaultLogoUrl = "https://hermes.dio.me/assets/diome/logo-full.svg" 
}) => {
  return (
    <header className="w-full bg-white p-4 flex justify-between items-center border-b border-gray-200">
      <div className="flex items-center">
        <a href="https://web.dio.me/home" target="_blank" rel="noopener noreferrer">
          <img
            src={defaultLogoUrl}
            alt="Logo"
            className="h-10 cursor-pointer"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.src = "https://hermes.dio.me/assets/diome/logo-full.svg";
            }}
          />
        </a>
      </div>
      <div className="flex items-center text-gray-700">
        <img src={lockIcon} alt="Lock Icon" className="h-4 w-4 mr-1" />
        <span className="text-sm font-medium">Pagamento 100% seguro</span>
      </div>
    </header>
  );
};

export default Header;
